var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEchelle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xE9chelle",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.92 1060",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#919191;}.cls-2{fill:#2d2d2d;}.cls-3{fill:#5b5b5b;}.cls-4{fill:#c44747;}.cls-5{fill:#d8d8d8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xE9chelle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xE9chelle-2",
    "data-name": "\\xE9chelle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3460.72,1573.91v22.44H3389.3V569h-30.6v17.34h11.22v60.2h-92.84v-60.2h11.22V569h-30.6V1596.35h-71.42v-22.44H3174V1629h12.24v-17.34h274.44V1629H3473v-55.09ZM3277.08,655.72h92.84v68.35h-92.84Zm0,76.51h92.84v66.32h-92.84Zm0,73.46h92.84v69.37h-92.84Zm0,77.54h92.84v67.33h-92.84Zm0,74.47h92.84v68.35h-92.84Zm0,78.56h92.84v64.27h-92.84Zm0,72.43h92.84v68.36h-92.84Zm0,77.54h92.84v66.31h-92.84Zm0,75.49h92.84V1328h-92.84Zm0,75.5h92.84v66.31h-92.84Zm0,75.5h92.84v65.52l-46.42.78-46.42-.78Zm0,77,46.42-.53,46.42.53v66.79l-45.91-1v0l-.51,0-.51,0v0l-45.91,1Zm92.84,105.56h-92.84l-.44-30.69,46.35.08h1l46.35-.08Z",
    transform: "translate(-3174.04 -569)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 103.04,
    y: 11.22,
    width: 11.22,
    height: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 184.66,
    y: 11.22,
    width: 11.22,
    height: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 195.88,
    y: 11.22,
    width: 4.08,
    height: 1015.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 98.96,
    y: 11.22,
    width: 4.08,
    height: 1015.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 1048.78,
    width: 12.24,
    height: 11.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 286.68,
    y: 1048.78,
    width: 12.24,
    height: 11.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 759,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 684,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 608,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 531,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 457,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 381,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 306,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 229,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 155,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 77,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 834,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 909,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 987,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.96,
    y: 1026,
    width: 93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 11.96,
    y: 1026,
    width: 72,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.96,
    y: 1026,
    width: 72,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEchelle);
export default __webpack_public_path__ + "static/media/echelle.001730a33769762742167973333f9517.svg";
export { ForwardRef as ReactComponent };